import { toUpperCaseFirstChar } from '../formatString';

export default (str: string): string => {
  return toUpperCaseFirstChar(str).split('_').join(' ');
};
